// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"340":"8891077f","353":"db017057","379":"6f492dc7","383":"ffa77e9a","451":"87d13628","477":"0ecd7a9a","675":"84d2f196","729":"7fad374f","750":"c2c5d3d9","887":"4fb98a52","978":"774766d9","993":"d8dfa30d"}[chunkId] + ".chunk.js";
};